import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../env.js";
import styles from "./Tenders.module.css";
import TendersDesktopTable from "./TendersDesktopTable";
import TendersMobileCard from "./TendersMobileCard";

const TendersTable = () => {
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(false);
  const currentDate = new Date()

  useEffect(() => {
    fetchTenders();
  }, []);

  async function fetchTenders() {
    setLoading(true);
    try {
      const res = await axios.get(`${REACT_APP_API_URL}/api/tender/get`);
      const allTenders = res.data || [];
      setTenders(allTenders);
    }
    catch (err) {
      console.error("Error fetching tenders:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container-fluid px-0">
      <div className={styles.bannerContainer}>
        <img
          src="/images/unsplash2.jpg"
          alt="Tenders Banner"
          className={`img-fluid w-100 ${styles.bannerImage}`}
        />
        <div className={`position-absolute top-50 start-50 translate-middle text-white text-center ${styles.bannerText}`}>
          <h2 className="fw-bold text-white">Tenders</h2>
        </div>
      </div>

      <div className="container-fluid py-4 px-3">
        {loading ? (
          <p className="text-center">Loading...</p>
        ) : tenders.length === 0 ? (
          <p className="text-center">No active tenders available.</p>
        ) : (
          <>
            <div className="d-none d-md-block">
              <TendersDesktopTable tenders={tenders} currentDate={currentDate} />
            </div>
            <TendersMobileCard tenders={tenders} currentDate={currentDate} />
          </>
        )}
      </div>
    </div>
  );
};

export default TendersTable;
